import { Trans } from '@lingui/react/macro'
import { Button, Card, Center, Stack, Text, Title } from '@mantine/core'
import { IconLinkOff } from '@tabler/icons-react'
import { Link, createFileRoute } from '@tanstack/react-router'

function LinkExpiredPage() {
  return (
    <Center mih="100vh" p="md">
      <Card withBorder maw={420} w="100%">
        <Stack gap="md" align="center" ta="center">
          <IconLinkOff size={48} color="var(--mantine-color-gray-6)" />
          <Title order={3}>
            <Trans>Link no longer valid</Trans>
          </Title>
          <Text size="sm" c="dimmed">
            <Trans>
              This link may have expired or is no longer available. Sign in to
              your Markku account to continue.
            </Trans>
          </Text>
          <Button component={Link} to="/" fullWidth>
            <Trans>Sign in to Markku</Trans>
          </Button>
        </Stack>
      </Card>
    </Center>
  )
}

export const Route = createFileRoute('/link-expired')({
  component: LinkExpiredPage,
})
